module.exports = __webpack_public_path__ + "assets/img/HH_Rivercove EC_RGB_lr.771be39c.jpg";